import { atomWithStorage } from 'jotai/utils';

const roleAtom = atomWithStorage('role', 'admin');

export { roleAtom };
export default roleAtom;
